import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { theme } from './styles/theme';
import Header from './components/Header';
import Footer from './components/Footer';
import Homepage from './pages/Homepage';
import ClaimsList from './pages/ClaimsList';
import ClaimDetail from './pages/ClaimDetail';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<Homepage />} />
          {/* Claims application routes */}
          <Route path="/claims" element={<ClaimsList />} />
          <Route path="/claims/:id" element={<ClaimDetail />} />
          {/* Placeholder routes for other pages */}
          <Route path="/auto-insurance" element={<div>Auto Insurance Page - Coming Soon!</div>} />
          <Route path="/home-insurance" element={<div>Home Insurance Page - Coming Soon!</div>} />
          <Route path="/business-insurance" element={<div>Business Insurance Page - Coming Soon!</div>} />
          <Route path="/life-insurance" element={<div>Life Insurance Page - Coming Soon!</div>} />
          <Route path="/about" element={<div>About Us Page - Coming Soon!</div>} />
          <Route path="/customer-portal" element={<div>Customer Portal - Coming Soon!</div>} />
          <Route path="/contact" element={<div>Contact Page - Coming Soon!</div>} />
          <Route path="/digital-transformation" element={<div>Digital Transformation Demo - Coming Soon!</div>} />
        </Routes>
        <Footer />
      </Router>
    </ThemeProvider>
  );
}

export default App;